// extracted by mini-css-extract-plugin
export default {"wrapper":"JO9vDI","wrapper--disabled":"BN_yQa","logo-img":"OBVes4","title":"W1gF8J","env":"VuIoih"};